<div fxLayout="column" fxLayoutAlign="space-between stretch" class="programs-container">
  <app-programs-joined></app-programs-joined>
  <app-programs-public></app-programs-public>
</div>
